const useUrlParameter = (url:string, parameter:string):string|null => {
	const stringArray = url?.split('/')
	const index = stringArray.findIndex((item) => item === parameter)
	return index !== -1 ? stringArray[index + 1] : null
}

export default useUrlParameter
window.useUrlParameter = useUrlParameter
